import React, { useEffect, useState } from 'react';
import './PaymentForm.css';

const PaymentForm = () => {
  const [amount, setAmount] = useState('');
  const [downloadLinks, setDownloadLinks] = useState([]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setAmount(urlParams.get('amount') || '');

    const storedDownloadLinks = sessionStorage.getItem('downloadLinks');
    if (storedDownloadLinks) {
      const parsedLinks = JSON.parse(storedDownloadLinks);
      const mappedBooks = parsedLinks.map(link => ({
        _id: link._id || link.id,
        userId: link.userId,
        price: parseFloat(link.price)
      }));
      setDownloadLinks(mappedBooks);
    }

    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || !downloadLinks.length) {
      alert('Missing amount or books.');
      return;
    }

    const email = prompt("Enter your email address for the receipt:");
    if (!email) {
      alert("Email is required.");
      return;
    }

    const reference = `FanonRef-${Date.now()}`;

    const handler = window.PaystackPop.setup({
      key: 'pk_live_d3890b51707d5b3c6883d7e1afa34c03c276c7a8',
      email,
      amount: parseFloat(amount) * 100, // Paystack expects cents
      currency: 'KES',
      ref: reference,
      callback: function (response) {
        alert('Payment successful. Ref: ' + response.reference);

        const salePayload = {
          books: downloadLinks.map(book => ({
            bookId: book._id || book.id,
            userId: book.userId,
            price: parseFloat(book.price)
          })),
          buyerEmail: email,
          totalAmountPaid: parseFloat(amount),
          reference: response.reference || reference
        };

        console.log('?? Sending sale data to backend:', salePayload);

        fetch('https://panafricanbookexchange-wandererspath.com/api/sales', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(salePayload)
        })
          .then(async res => {
            const contentType = res.headers.get('content-type');
            const isJson = contentType && contentType.includes('application/json');

            if (!res.ok) {
              const rawError = isJson ? await res.json() : await res.text();
              console.error('? Server error response:', { status: res.status, error: rawError });

              let message = 'Unknown error from server';
              if (typeof rawError === 'string') {
                message = rawError;
              } else if (typeof rawError === 'object' && rawError.message) {
                message = rawError.message;
              }

              throw new Error(message);
            }

            return isJson ? await res.json() : {};
          })
          .then(data => {
            console.log('? Sale recorded:', data.message);
            alert('Sale recorded successfully.');

            // Save saleId so /download can fetch from backend
            if (data.saleId) {
              sessionStorage.setItem('saleId', data.saleId);
            }

            window.location.href = '/download';
          })
          .catch(err => {
            console.error('? Failed to record sale:', err);
            console.log('?? Sale payload that failed:', salePayload);

            alert(`Payment was made, but sale could not be recorded: ${err.message || err}. Please contact support.`);
          });
      },
      onClose: function () {
        alert('Transaction was not completed.');
      }
    });

    handler.openIframe();
  };

  return (
    <div>
      <h2 className="payment-heading">Payment Details</h2>
      {amount && <p>Amount: {amount} Fanon</p>}
      <form onSubmit={handleSubmit}>
        <button type="submit">Proceed to Payment</button>
      </form>

      <div>
        {downloadLinks.length > 0 ? (
          <ul>
            {downloadLinks.map((book, index) => (
              <li key={index}>
                <span className="book-link">
                  Book ID: {book._id} | Price: {book.price}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p>Go back to purchase.</p>
        )}
      </div>
    </div>
  );
};

export default PaymentForm;
